import { gql } from "@apollo/client";

export const GET_EXPENSE_TYPE_WITH_PAGINATION = gql`
  query GetExpenseTypePagination(
    $page: Int
    $keyword: String
    $limit: Int
    $pagination: Boolean
    $groupExpense: String
  ) {
    getExpenseTypePagination(
      page: $page
      keyword: $keyword
      limit: $limit
      pagination: $pagination
      groupExpense: $groupExpense
    ) {
      data {
        _id
        title
        code
        remark
        groupExpense {
          _id
          title
          code
          remark
          createdAt
        }
        createdAt
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;

export const CREATE_EXPENSE_TYPE = gql`
  mutation CreateExpenseType(
    $title: String!
    $groupExpense: String!
    $remark: String
    $code: String
  ) {
    createExpenseType(
      title: $title
      groupExpense: $groupExpense
      remark: $remark
      code: $code
    ) {
      status
      message
    }
  }
`;

export const UPDATE_EXPENSE_TYPE = gql`
  mutation UpdateExpenseType(
    $id: String!
    $title: String!
    $groupExpense: String!
    $remark: String
    $code: String
  ) {
    updateExpenseType(
      _id: $id
      title: $title
      groupExpense: $groupExpense
      remark: $remark
      code: $code
    ) {
      status
      message
    }
  }
`;

export const DELETE_EXPENSE_TYPE = gql`
  mutation DeleteExpenseType($id: String!) {
    deleteExpenseType(_id: $id) {
      status
      message
    }
  }
`;
